import { siteData } from "@/lib/aht/pageData";

const U = () => siteData.ui.units; // read lazily: siteData is assembled at runtime
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// Replace {token} placeholders in interface copy.
export const fill = (tpl, vars = {}) =>
  String(tpl).replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined && vars[k] !== null ? vars[k] : ""));

// Values may be plain or { value, verify }.
export const val = (x) => (x && typeof x === "object" && "value" in x ? x.value : x);
export const needsVerify = (x) => Boolean(x && typeof x === "object" && x.verify);

export const fmtInt = (n) => Math.round(n).toLocaleString("en-US");
export const fmtMoney = (n) => {
  const r = Math.round(n);
  const s = Math.abs(r).toLocaleString("en-US");
  return r < 0 ? `-$${s}` : `$${s}`;
};
export const fmtPpsf = (n) => `$${fmtInt(n)}${U().perSqft}`;
export const fmtSqft = (n) => fill(U().sqft, { n: fmtInt(n) });
export const fmtDays = (n) => fill(n === 1 ? U().day : U().days, { n: fmtInt(n) });
export const fmtHomes = (n) => fill(n === 1 ? U().home : U().homes, { n });

// Up to `max` decimals, trailing zeros trimmed: 100%, 95.37%, 103.7%.
export const fmtPct = (n, max = 2) => `${Number(n.toFixed(max)).toString()}%`;

// Always one decimal: 100.0%, 96.0%, 95.4%, 103.7%. Used for every "% of original" value.
export const fmtPct1 = (n) => `${n.toFixed(1)}%`;

export const fmtDecimal = (n, decimals) =>
  n.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

// "2026-05-18" -> "May 18, 2026" (no timezone shifts).
export const fmtDate = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};

// Short axis money: $1.0M, $1.25M, $950K.
export const fmtShortMoney = (n) => {
  if (Math.abs(n) >= 1000000) {
    const m = n / 1000000;
    const s = Number.isInteger(m * 10) ? m.toFixed(1) : m.toFixed(2);
    return `$${s}M`;
  }
  if (Math.abs(n) >= 1000) return `$${Math.round(n / 1000)}K`;
  return fmtMoney(n);
};

export const listJoin = (items) => {
  if (items.length <= 1) return items.join("");
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
};

// Headlines never leave a single word alone on the last line: tie the last two words together.
export const noOrphan = (s) => {
  if (typeof s !== "string") return s;
  const i = s.trim().lastIndexOf(" ");
  return i > 0 ? `${s.slice(0, i)}\u00A0${s.slice(i + 1)}` : s;
};
